var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 9.00004C8.72001 9.00004 10.964 11.036 11.292 13.6667H0.708008C1.03601 11.036 3.28001 9.00004 6.00001 9.00004ZM4.79134 10.52C3.83534 10.8227 3.03067 11.4754 2.53334 12.3334H6.00001L4.79134 10.52ZM7.20934 10.52L6.00001 12.3334H9.46601C8.96934 11.4754 8.16468 10.8227 7.20934 10.52ZM10 0.333374V4.33337C10 6.54271 8.20934 8.33337 6.00001 8.33337C3.79067 8.33337 2.00001 6.54271 2.00001 4.33337V0.333374H10ZM3.33334 4.33337C3.33334 5.80671 4.52667 7.00004 6.00001 7.00004C7.47334 7.00004 8.66667 5.80671 8.66667 4.33337H3.33334ZM8.66667 1.66671H3.33334V3.00004H8.66667V1.66671Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.e20ad945bf5f854446cc51aa96551cc8.svg";
export { ForwardRef as ReactComponent };